import useStyles from '../styles/Map.styles'
import { MapProps } from '../types'

const MapView: React.FC<MapProps> = ({ map }) => {
    const classes = useStyles()

    return (
        <div className={classes.mapContainer}>
            <div ref={map.mapRef} className='map-container map'></div>
        </div>
    )
}

export default MapView
